// import http from './http'
// import APIs from '@utils/APIs.js'
// const API = new APIs(http)
import http from './http'
import APIs from '@utils/APIs.js'

const API = new APIs(http)

export default API
